import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { settingChangeShareUser } from 'services/setting'

export default function useSetShareUser(refetch: (() => void) | undefined) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IChangeShareSettingPayload) => {
            return settingChangeShareUser(payload)
        },
        onSuccess: (data) => {
            refetch && refetch()
            toast.success('تغییر سهم با موفقیت انجام شد')
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { mutate }
}
